<template>
	<div class="task-list">
		<div v-if="taskState === 3" class="operate-area">
			<div>
				<van-checkbox @change="onChangeCheckAll" v-if="isShowEdit" v-model="checkAll" shape="square"
					>全选</van-checkbox
				>
			</div>
			<!--<div class="operate-wrap">-->
			<!--	<span v-if="isShowEdit" class="del">删除</span>-->
			<!--	<span @click="isShowEdit = !isShowEdit">编辑</span>-->
			<!--	<span @click="clear">清空</span>-->
			<!--</div>-->
		</div>
		<van-list
			v-model:loading="loading"
			:immediate-check="!props.disabledAutoLoad"
			:finished="finished"
			:finished-text="list.length ? '没有更多了' : ''"
			@load="onLoad"
		>
			<div v-for="item in list" :key="item.id">
				<TaskItem :item="item" :keywords="keywords" :isShowEdit="isShowEdit" />
			</div>
			<Empty
				v-if="!list.length && !loading"
				:title="props.type === 'search' ? '暂无搜索结果' : '暂无任务'"
				:type="props.type"
			/>
		</van-list>
	</div>
</template>
<script setup lang="ts">
import TaskItem from '@/views/pages/task/components/taskItem.vue'
import Empty from '@/components/XEmpty.vue'
import { inject } from 'vue'
import { Dialog } from 'vant'
import { useAuthStore } from '@/store/auth'
import { getDoneTaskData, getMyProcessTaskData, getTodoTaskData } from '@/api'

const taskState = inject<any>('taskState')
const props = defineProps<{
	disabledAutoLoad?: boolean // true 默认为搜索页面，不自动加载数据
	type?: string
	keywords?: string
}>()
const emit = defineEmits(['loading'])

const checkAll = ref(false)
const isShowEdit = ref(false)

const list = ref<any>([])
const loading = ref(false)
const finished = ref(false)
const page = ref(1)
const userStore = useAuthStore()
const keywords = ref('')

const onChangeTag = () => {
	page.value = 1
	list.value = []
	finished.value = false
	onLoad()
}

const onChangeCheckAll = () => {
	list.value.forEach((item: any) => {
		item.checked = checkAll.value
	})
}

const clear = () => {
	Dialog.confirm({
		title: '确认清空回收站',
		confirmButtonColor: '#BD3A36'
	})
		.then(() => {
			// on confirm
		})
		.catch(() => {
			// on cancel
		})
}

const onLoad = async () => {
  // 如果是搜索页面，并且没有关键字，则不去调用接口
	if (props.disabledAutoLoad && !keywords.value) {
		return
	}
	loading.value = true
	try {
		if (taskState.value === 0) {
			const data = {
				pageNumber: page.value,
				pageSize: 100,
				ASSIGN_ID: userStore.userInfo.F_UserId
			}
			const res = await getTodoTaskData(data)
			const resData = res.data || []
			loading.value = false
			list.value = list.value.concat(resData)
			if (resData.length === 0) {
				finished.value = true
			} else {
				page.value++
			}
		}
		if (taskState.value === 1) {
			const data = {
				pageNumber: page.value,
				pageSize: 100,
				ACTUAL_OWNER_ID: userStore.userInfo.F_UserId
			}
			const res = await getDoneTaskData(data)
			const resData = res.data || []
			loading.value = false
			list.value = list.value.concat(resData)
			if (resData.length === 0) {
				finished.value = true
			} else {
				page.value++
			}
		}
		if (taskState.value === 2) {
			const data = {
				pageNumber: page.value,
				pageSize: 100,
				PROCESS_INSTANCE_INITIATOR_ID: userStore.userInfo.F_UserId
			}
			const res = await getMyProcessTaskData(data)
			const resData = res.data || []
			loading.value = false
			list.value = list.value.concat(resData)
			if (resData.length === 0) {
				finished.value = true
			} else {
				page.value++
			}
		}
		if (taskState.value === 3) {
			loading.value = false
			finished.value = true
		}
		if (keywords.value) {
			list.value = list.value.filter((v) => {
				const name = v.process_instance_subject || v.subject || v.process_NAME
				return name.includes(keywords.value)
			})
		}
	} catch (e) {
		loading.value = false
		finished.value = true
		console.log(e)
	}
}

watch(taskState, () => {
	onChangeTag()
})
watch(loading, (newVal) => {
	emit('loading', newVal)
})
watch(
	() => props.keywords,
	(value) => {
		keywords.value = value as string
		onChangeTag()
	}
)
</script>

<style scoped lang="scss">
.task-list {
	padding-bottom: 44px;
	.operate-area {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 15px;
		padding: 0 15px;
		box-sizing: border-box;
		.operate-wrap {
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: 14px;
			color: #424649;
			line-height: 16px;
			text-align: left;
			font-style: normal;
			text-transform: none;
			> span {
				padding-left: 15px;
			}
			.del {
				color: $primaryColor;
			}
		}
	}
}
</style>
